import {useMutation, useQueryClient} from '@tanstack/react-query';
import {fetchCollectionShareUpdate} from './fetchCollectionShareUpdate';
import {Collection} from './types';

/**
 * This mutation hook is used to update the Collection share.
 */
export const useCollectionShareUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchCollectionShareUpdate,
    onSuccess(data) {
      queryClient.setQueryData<Collection>(['collections', {id: data.collectionId}], (old) => {
        if (!old) {
          return old;
        }
        return {
          ...old,
          share: data,
        };
      });
    },
  });
};
